import { useNavigate } from "react-router-dom";

const Statistics = () => {
  const navigate = useNavigate();

  const isLoggedIn = !!localStorage.getItem("authToken") || !!localStorage.getItem("token");
  if (isLoggedIn) {
    return null;
  }

  return (
    <div className="w-full max-w-5xl mx-auto px-4 my-16">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Left — Planning an event */}
        <div className="bg-[#F2F0EB] rounded-2xl p-8 md:p-10 flex flex-col justify-between gap-6">
          <div>
            <h3
              className="text-2xl md:text-3xl font-bold text-gray-900 mb-3"
              style={{ fontFamily: "CabinetGrotesk-Bold" }}
            >
              Planning an event?
            </h3>
            <p className="text-gray-600 text-sm md:text-base">
              Discover trusted professionals for your next event.
            </p>
          </div>
          <button
            onClick={() => navigate("/b2b")}
            className="self-start bg-[#FF512F] hover:bg-[#e64410] transition-colors text-white font-semibold py-3 px-8 rounded-lg text-base"
          >
            Post My Event
          </button>
        </div>

        {/* Right — Are you a professional */}
        <div className="bg-[#2E2E2E] rounded-2xl p-8 md:p-10 flex flex-col justify-between gap-6">
          <div>
            <h3
              className="text-2xl md:text-3xl font-bold text-white mb-3"
              style={{ fontFamily: "CabinetGrotesk-Bold" }}
            >
              Are you an event professional?
            </h3>
            <p className="text-gray-400 text-sm md:text-base">
              Create your profile and connect with new opportunities.
            </p>
          </div>
          <button
            onClick={() => navigate("/join-us")}
            className="self-start bg-[#FF512F] hover:bg-[#e64410] transition-colors text-white font-semibold py-3 px-8 rounded-lg text-base"
          >
            Join as a Professional
          </button>
        </div>
      </div>
    </div>
  );
};

export default Statistics;
